import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { Carousel } from '../Carousel';
import { ZoomableImage } from '../ZoomableImage';
import { PROJECT_PAGES } from '../../data/catio';

/** Six real project pages, Volume 01 → Volume 05. One large page per view on mobile. */
export function PageProofSection() {
  return <section aria-labelledby="proof-title" className="bg-paper py-12 sm:py-20" data-id="element-236" data-mp="1stzu675jk8fg">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-237" data-mp="2gij4stc2cxap">
        <SectionHeading id="proof-title" eyebrow="Real CATIO READY™ pages" title="This Is Not a Generic DIY Ebook. These Are Actual Build Plans." lead="See the real pages you’ll build from." data-id="element-238" data-mp="2lhvz1z59l6nb" />
        <div className="mt-8 sm:mt-10" data-id="element-239" data-mp="2br11vzqhcmn3">
          <Carousel items={PROJECT_PAGES} getKey={page => page.src} label="Real CATIO READY™ project pages" itemClassName="w-[84%] sm:w-[44%] lg:w-[30%]" renderItem={page => <figure className="flex w-full flex-col" data-id="element-241" data-mp="3t60s6bi1oog8">
                <ZoomableImage image={page} className="overflow-hidden rounded-[8px] shadow-[0_22px_40px_-26px_rgba(28,31,28,0.5)] ring-1 ring-black/5" imgClassName="aspect-[1530/1980] w-full object-cover" data-id="element-242" data-mp="3t4plo3x7t2lf" />
                <figcaption className="mt-3 flex items-baseline justify-between gap-3" data-id="element-243" data-mp="11ghsagqo0kd">
                  <span className="font-display text-[1.1rem] leading-snug text-ink" data-id="element-244" data-mp="fqm9zeh5sqir">
                    {page.title}
                  </span>
                  <span className="label-tech shrink-0 text-ember" data-id="element-245" data-mp="osltcdfnc6ov">
                    Vol {page.volume}
                  </span>
                </figcaption>
              </figure>} data-id="element-240" data-mp="2bpznpme63k15" />
        </div>
      </div>
    </section>;
}